import React, { useEffect, useRef } from "react";
import { useLocation, Route, Routes, Navigate, useNavigate } from "react-router-dom";
import { Container } from "reactstrap";
// core components
import AdminNavbar from "components/Navbars/AdminNavbar.js";
import AdminFooter from "components/Footers/AdminFooter.js";
import AdminSidebar from "components/Sidebar/AdminSidebar.js";
import Header from "components/Headers/Header.js";
import routes from "routes.js";
import Disabled from "./Disabled";

const Admin = (props) => {
  const mainContent = React.useRef(null);
  const location = useLocation();

  // Pages where the top banner header should NOT show.
  const HEADER_HIDDEN_ON = [
    "/admin/loan-list",
    "/admin/customer-list",
    "/admin/collection",
    "/admin/repayment",
    "/admin/lead-list",
    "/admin/dashboard",
  ];
  const showHeader = !HEADER_HIDDEN_ON.some((p) => location.pathname.startsWith(p));

  const getRoutes = (routes) => {
    return routes.map((prop, key) => {
      if (prop.layout === "/admin") {
        return (
          <Route path={prop.path} element={prop.component} key={key} exact />
        );
      } else {
        return null;
      }
    });
  };

  const getBrandText = (path) => {
    for (let i = 0; i < routes.length; i++) {
      if (
        props?.location?.pathname.indexOf(routes[i].layout + routes[i].path) !==
        -1
      ) {
        return routes[i].name;
      }
    }
    return "Brand";
  };

  return (
    <>
      <Disabled/>
      <AdminSidebar
        logo={{
          innerLink: "/admin/lead-list",
          imgSrc: require("../assets/img/brand/logo.png"),
          imgAlt: "Salora LMS",
        }}
      />
      <div className="main-content" ref={mainContent}>
        <AdminNavbar
          {...props}
          brandText={getBrandText(props?.location?.pathname)}
        />
        {showHeader && <Header />}
        <Routes>
          {getRoutes(routes)}
          <Route path="*" element={<Navigate to="/admin/lead-list" replace />} />
        </Routes>
        <Container fluid>
          <AdminFooter />
        </Container>
      </div>
    </>
  );
};

export default Admin;